<div class="dialog-container">
  <h1 mat-dialog-title class="dialog-title theme-card cardWithShadow">
    <mat-icon class="title-icon text-primary">info</mat-icon>
    {{ action }} Application Log Details
  </h1>

  <mat-dialog-content class="dialog-content">
    <div class="log-details-container">
      <!-- Primary Information Section -->
      <div class="info-section primary-section cardWithShadow theme-card">
        <h3 class="section-title">
          <mat-icon class="text-primary">description</mat-icon>
          Basic Information
        </h3>
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">ID</label>
            <span class="info-value bg-light">{{ applicationLog.id }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Log ID</label>
            <span class="info-value bg-light">{{ applicationLog.logID }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Log Date</label>
            <span class="info-value bg-light">{{
              applicationLog.logDate
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Type</label>
            <span class="info-value bg-light">{{ applicationLog.type }}</span>
          </div>
        </div>
      </div>

      <!-- Description Section -->
      <div class="info-section cardWithShadow theme-card">
        <h3 class="section-title">
          <mat-icon class="text-primary">category</mat-icon>
          Description
        </h3>
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Type Description</label>
            <span class="info-value bg-light">{{
              applicationLog.typeDescription
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Description</label>
            <span class="info-value bg-light">{{
              applicationLog.description
            }}</span>
          </div>
        </div>
      </div>

      <!-- Application Information Section -->
      <div class="info-section cardWithShadow theme-card">
        <h3 class="section-title">
          <mat-icon class="text-primary">apps</mat-icon>
          Application Details
        </h3>
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Client ID</label>
            <span class="info-value bg-light">{{
              applicationLog.clientID || 'N/A'
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Application ID</label>
            <span class="info-value bg-light">{{
              applicationLog.applicationId || 'N/A'
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Application Name</label>
            <span class="info-value bg-light">{{
              applicationLog.applicationName
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Session ID</label>
            <span class="info-value bg-light">{{
              applicationLog.sessionID || 'N/A'
            }}</span>
          </div>
        </div>
      </div>

      <!-- User and Network Information Section -->
      <div class="info-section cardWithShadow theme-card">
        <h3 class="section-title">
          <mat-icon class="text-primary">person</mat-icon>
          User & Network
        </h3>
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">User Name</label>
            <span class="info-value bg-light">{{
              applicationLog.userName || 'N/A'
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Scope</label>
            <span class="info-value bg-light">{{
              applicationLog.scope || 'N/A'
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">IP Address</label>
            <span class="info-value bg-light">{{
              applicationLog.ip || 'N/A'
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Host Name</label>
            <span class="info-value bg-light">{{
              applicationLog.hostName || 'N/A'
            }}</span>
          </div>
        </div>
      </div>

      <!-- Record Information Section -->
      <div class="info-section cardWithShadow theme-card">
        <h3 class="section-title">
          <mat-icon class="text-primary">schedule</mat-icon>
          Record Information
        </h3>
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Record Date</label>
            <span class="info-value bg-light">{{
              applicationLog.recordDate
            }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Record Time</label>
            <span class="info-value bg-light">{{
              applicationLog.recordTime
            }}</span>
          </div>
        </div>
      </div>

      <!-- Details Section (if available) -->
      <div class="info-section cardWithShadow theme-card">
        @if (applicationLog.details) {
          <h3 class="section-title">
            <mat-icon class="text-primary">code</mat-icon>
            Additional Details
          </h3>
          <div class="details-container">
            <pre class="details-content bg-light">{{
              applicationLog.details
            }}</pre>
          </div>
        }
      </div>

      <!-- Raw Log Stream Section (if available) -->
      <div class="info-section cardWithShadow theme-card">
        @if (applicationLog.rawLogStream) {
          <h3 class="section-title">
            <mat-icon class="text-primary">data_object</mat-icon>
            Raw Log Stream
          </h3>
          <div class="details-container">
            <pre class="details-content bg-light">{{
              applicationLog.rawLogStream
            }}</pre>
          </div>
        }
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions theme-card">
    <button mat-button mat-dialog-close class="close-button bg-light">
      <mat-icon class="text-accent">close</mat-icon>
      Close
    </button>
  </mat-dialog-actions>
</div>
